<template>
  <div class="be-wrapper be-fixed-sidebar app-layout">
    <navbar></navbar>
    <sidebar v-if="page.sidebarOpen"></sidebar>

    <div class="be-content">

      <div :class="page.adArea ? 'ad-container' : ''">
        <div class="left">
          <router-view></router-view>
        </div>
        <div class="right">
          <VerticalAd v-if="page.adArea" :containerClass="''" :key="currentRoute"></VerticalAd>

          <VerticalAd v-if="page.adArea" :containerClass="''" :key="currentRoute"></VerticalAd>
        </div>
      </div>
      <div class="clear"></div>
      <div class="bottom-ad xs-p-20 xs-mb-20">
        <HorizontalAd :containerClass="''"></HorizontalAd>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex'
import Navbar from '../navbar/Navbar'
import Sidebar from '../sidebar/Sidebar'
import HorizontalAd from '../shared/ads/HorizontalAd'
import VerticalAd from '../shared/ads/VerticalAd'

export default {
  components: {
    Navbar,
    Sidebar,
    HorizontalAd,
    VerticalAd
  },

  computed: {
    ...mapState([
      'page',
    ]),

    currentRoute() {
      return this.$route.name;
    }
  },
}
</script>

<style type="scss">
  .main-content {
    /* This allows the editor to be full height */
    
  }

  .ad-container {position:relative;}
  .ad-container .left {margin-right:275px;}
  .ad-container .right {position:absolute;top:25px;right:25px;width:250px;}

  @media (min-width: 1101px) {
    .bottom-ad {display:none;}
  }
  @media (max-width: 1100px) {
    .ad-container { position: static; }
    .ad-container .left { margin-right: 0px; }
    .ad-container .right { display:none; }
  }

</style>




// WEBPACK FOOTER //
// App.vue?ae4ac036